
/* injects from baggage-loader */

'use strict';

import RaiseFundsComponent from './raise-funds.component';

const RaiseFundsPageModule = angular.module('raise-funds-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('raise-funds', {
        url: '/raise-funds',
        component: 'raiseFunds',
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('raiseFunds', new RaiseFundsComponent());

export default RaiseFundsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/raise-funds/raise-funds.module.js